import { createSlice } from '@reduxjs/toolkit'

const commodityCacheSlice = createSlice({
  name: 'commodityCache',
  initialState: {
    cache: {},
  },
  reducers: {
    storeCommodityCacheEntry(state, action) {
      const { searchText, ...partialData } = action.payload

      state.cache[searchText] = {
        ...(state.cache[searchText] || {}),
        ...partialData,
        timestamp: Date.now(),
      }
    },

    resetAllCommodityCache(state) {
      state.cache = {}
    },
  },
})

export const { storeCommodityCacheEntry, resetAllCommodityCache } =
  commodityCacheSlice.actions
export default commodityCacheSlice.reducer
